import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  background-color: rgb(250,250,250);
  
  .chat-room{
    display: flex;
    flex-direction: column;
    max-width: 768px;
    width: 100%;
    background-color: white;
    
    *{
      box-sizing: border-box;
    }
    
    .chat-room-header{
      position: relative;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      height: 44px;
      border-bottom: 1px solid rgb(245,245,245);

      a{
        text-decoration: none;
        margin-right: 12px;
        background-color: rgb(245,245,245);
        
        &:hover{
          background-color: rgb(235,235,235);
        }
      }
      .icon{
        position: relative;
        width: 44px;
        height: 44px;
        display: flex;;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        
      }

      .slack-alert-button {
        border: none;
        margin-left: 8px;
        padding: 0;
        display: flex;
        width: max-content;
        height: 32px;
        align-items: center;
        gap: 4px;
        border-radius: 4px;
        background-color: rgb(245,245,245);
        font-size: 14px;
        height: 32px;
        cursor: pointer;
        padding: 0 8px;

        .icon {
          width: max-content;
        }

        &.active {
          background-color: rgba(0,100,240);
          color: white;
        }
      }
    }
    .chat-room-body{
      flex: 1;
      overflow-y: auto;
      
      .message-item{
        padding: 4px 16px;
        position: relative;
        display: flex;
        flex-direction: column-reverse;

        &.user{
          .message-wrapper{
            flex-direction: row-reverse;
            .message{
              background-color: rgb(235,235,235);
            }
          }
        }

        &.admin{
          .message-wrapper{
            .message{
              background-color: rgba(0,100,240, 0.8);
              color: white;
            }
            .message-time{
              align-items: flex-end;
            }
          }
        }

        .message-wrapper{
          position: relative;
          display: flex;
          width: 100%;
          justify-content: flex-end;
          align-items: flex-end;
          gap: 6px;
          
          &.pending{
            .message{
              background-color: rgba(0,100,240, 0.4);
            }
          }
          
          .message-stack{
            display: flex;
            flex-direction: column;
            max-width: calc(100% - 100px);
            min-width: 0;

            &.admin{
              align-items: flex-end;

              .message-translation{
                text-align: right;
              }
            }

            &.user{
              align-items: flex-start;
            }
          }

          .message{
            position: relative;
            margin: 0px;
            padding: 10px 14px;
            border-radius: 8px;
            max-width: 100%;
            font-size: 0.9rem;
            line-height: 1.5;
            white-space: pre-wrap;
            word-break: break-word;
            
            img{
              margin-bottom: 12px;
            }

            div{
              word-break: break-all;
            }

            .btn-translate-message{
              display: block;
              margin-top: 8px;
              padding: 4px 8px;
              border: none;
              border-radius: 4px;
              background-color: rgba(0,0,0,0.08);
              color: rgb(80,80,80);
              font-size: 0.75rem;
              cursor: pointer;

              &:disabled{
                opacity: 0.6;
                cursor: default;
              }
            }
          }

          .message-translation{
            margin-top: 4px;
            padding: 0 4px;
            font-size: 0.78rem;
            line-height: 1.4;
            color: rgb(140,140,140);
            white-space: pre-wrap;
            word-break: break-word;
          }
          .delete-message{
            padding: 0px;
            margin: 0px;
            min-width: 32px;
            height: 100%;
            max-height: 100px;
            border-radius: 6px;
            
            background-color: rgb(235,235,235);
            color: black;
            align-items: center;

            display: flex;
            justify-content: center;
            
            i{
              font-size: 16px;
              display: flex;
              color: black;
            }
            cursor: pointer;
            &:hover{
              background-color: rgb(220,220,220);
            }
            
            &.pending{
              
            }
          }

          .message-time{
            position: relative;
            z-index: 100;
            min-width: 80px;
            margin: 0px;
            display: flex;
            flex-direction: column;

            .admin-info{
              position: relative;
              display: flex;
              white-space: nowrap;
              align-items: center;

              &:hover{
                span{
                  text-decoration: underline;
                  text-underline: rgb(0, 100, 240);
                }
                .tooltip{
                  display: block;
                }
              }

              .tooltip{
                position: absolute;
                left: 0;
                top: -36px;
                white-space: nowrap;
                background-color: rgba(0,0,0,0.6);
                border-radius: 6px;
                padding: 8px;
                color: white;
                display: none;
              }
            }
            span{
              font-size: 0.7rem;
              color: rgb(160,160,160);

              &.blue{
                color: rgba(0,100,240, 0.5);
              }
            }
          }
        }

        .message-user-name{
          margin: 6px 0px;
          font-size: 0.9rem;
          color: rgb(150,150,150);
        }
      }
    }
    .chat-room-footer{
      position: relative;
      margin: 0px;
      padding: 12px;
      display: flex;
      gap: 12px;
      border: none;
      border-top: 1px solid rgb(235,235,235);
      
      .image-wrapper{
        position: absolute;
        height: 120px;
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 6px rgba(0,0,0,0.3);
        
        .btn-remove-image{
          position: absolute;
          top: -20px;
          right: -20px;
          
          width: 40px;
          height: 40px;
          background-color: white; 
          cursor: pointer;
          border: 1px solid rgb(235,235,235);
          &:hover{
            background-color: rgb(245,245,245);
          }
        }
      }
      
      .btn-icon{
        position: relative;
        background-color: rgb(240,240,240);
        border-radius: 6px;
        cursor: pointer;
        overflow: hidden;
        
        &.submit{
          background-color: rgb(0,100,240);
          .icon{
            color: white;  
          }
          &:hover{ &:after{background-color: rgb(255,255,255,0.1);} }
          &:active{ &:after{background-color: rgb(255,255,255,0.2);} }
        }

        &:hover, &:active{ &:after{display: block;} }
        &:active{ &:after{background-color: rgb(0,0,0,0.1);} }

        &:after{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgb(0,0,0,0.05);
          content: "";
          display: none;
        }

        .icon{
          font-size: 20px;
          font-weight: 500;
          color: blue;
        }
      }
      .translate-controls{
        flex-shrink: 0;
        display: flex;
        align-items: center;
        gap: 6px;
      }
      .language-select{
        height: 44px;
        width: 56px;
        padding: 0 4px;
        border: none;
        border-radius: 6px;
        background-color: rgb(240,240,240);
        font-size: 1.1rem;
        line-height: 1;
        cursor: pointer;
        appearance: none;
        text-align: center;
        text-align-last: center;
      }
      .btn-translate{
        width: auto;
        min-width: max-content;
        height: 44px;
        padding: 0 14px;
        border: none;
        border-radius: 6px;
        background-color: rgb(240,240,240);
        color: rgb(0,100,240);
        font-size: 0.8rem;
        font-weight: 600;
        white-space: nowrap;
        flex-shrink: 0;
        cursor: pointer;

        &:disabled{
          color: rgb(160,160,160);
          cursor: default;
        }
      }
      .translation-preview{
        flex: 1;
        min-width: 0;
        border-radius: 6px;
        background-color: rgb(245,245,245);
        border: 1px solid rgb(230,230,230);
        padding: 8px 10px;
        display: flex;
        flex-direction: column;
        gap: 4px;

        .translation-preview-header{
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 0.7rem;
          color: rgb(120,120,120);
          text-transform: uppercase;
          letter-spacing: 0.03em;
        }

        .btn-dismiss-preview{
          width: 24px;
          height: 24px;
          padding: 0;
          border: none;
          border-radius: 4px;
          background: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;

          .icon{
            font-size: 14px;
            color: rgb(120,120,120);
          }

          &:hover{
            background-color: rgb(230,230,230);
          }
        }

        .translation-preview-body{
          font-size: 0.9rem;
          line-height: 1.45;
          white-space: pre-wrap;
          word-break: break-word;
        }
      }
      textarea{
        border-radius: 6px;
        resize: none;
        font-size: 0.9rem;
        background-color: rgb(245,245,245);
        border: 1px solid rgb(230,230,230);
      }
    }
  }
`;
